/* ============================================================
   BB Slider Quick-Add + Warm-Up (no block edits)
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- 1) Instant optimistic quick-add ---------------- */

  function parseCents(txt) {
    if (!txt) return 0;
    var n = String(txt).replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var f = parseFloat(n);
    return isNaN(f) ? 0 : Math.round(f * 100);
  }

  function classStr(el) {
    var c = el.className;
    return (c && c.baseVal !== undefined) ? c.baseVal : String(c || '');
  }

  function scrapePrices(card) {
    var box = card.querySelector('[class*="product-price"]') || card;
    var leaves = [].slice.call(box.querySelectorAll('*')).filter(function (e) {
      return e.children.length === 0 && /\$\s?\d/.test(e.textContent || '');
    });
    var cur = 0, cmp = 0;
    leaves.forEach(function (e) {
      var cents = parseCents(e.textContent);
      if (!cents) return;
      var isCompare = /compare|strike|was|original/i.test(classStr(e)) || e.tagName === 'S' || e.tagName === 'DEL';
      if (!isCompare) {
        try { if ((getComputedStyle(e).textDecorationLine || '').indexOf('line-through') > -1) isCompare = true; } catch (_) {}
      }
      if (isCompare) { if (cents > cmp) cmp = cents; }
      else { if (cur === 0 || cents < cur) cur = cents; }
    });
    if (!cur && cmp) { cur = cmp; cmp = 0; }
    return { priceCents: cur, compareCents: (cmp > cur ? cmp : 0) };
  }

  function textOf(card, sel) {
    var e = card.querySelector(sel);
    return e ? (e.textContent || '').trim() : '';
  }

  function buildOptimistic(btn) {
    var variantId = btn.dataset.variantId;
    var size = btn.dataset.size;
    if (!variantId) return null;
    var card = btn.closest('[class*="tabbed-slider"][class*="card-inner-"]')
            || btn.closest('[class*="card-inner-"]')
            || btn.closest('li, article');
    if (!card) return null;
    var img = card.querySelector('[class*="image-wrapper"] img, [class*="slider-image"] img, img');
    var link = card.querySelector('a[href*="/products/"]');
    var prices = scrapePrices(card);
    return {
      variantId: variantId,
      size: size || '',
      title: textOf(card, '[class*="product-title"]'),
      vendor: textOf(card, '[class*="product-vendor"]'),
      image: img ? (img.currentSrc || img.src || img.getAttribute('src') || '') : '',
      url: link ? link.getAttribute('href') : '',
      priceCents: prices.priceCents,
      compareCents: prices.compareCents,
      stock: null
    };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add-trigger]');
    if (!btn || btn.disabled) return;
    var opt = buildOptimistic(btn);
    document.dispatchEvent(new CustomEvent('cart:adding', {
      bubbles: true,
      detail: (opt && opt.priceCents) ? { optimistic: opt } : {}
    }));
  }, true);

  /* ---------------- 2) Warm up the lazy sliders early ---------------- */

  function warmSliders() {
    var hosts = document.querySelectorAll('[class*="ai-tabbed-slider-"]');
    for (var i = 0; i < hosts.length; i++) {
      var el = hosts[i];
      if (!/^TABBED-PRODUCT-SLIDER/.test(el.tagName)) continue;
      try {
        if (typeof el._init === 'function' && !el._initialised) el._init();
        if (typeof el.loadRecommendations === 'function') el.loadRecommendations();
        if (typeof el.loadRecentlyViewed === 'function') el.loadRecentlyViewed();
      } catch (_) {}
    }
  }

  function scheduleWarm() {
    var ric = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
    ric(function () { warmSliders(); });
    setTimeout(warmSliders, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleWarm);
  } else {
    scheduleWarm();
  }
})();

/* =============================================================
   BB header cart-bubble sync for optimistic quick-adds.
   Bumps the header <cart-icon> instantly on 'cart:adding' then reconciles to the
   authoritative /cart.js count on 'cart:updated' / 'cart:add-failed'. PDP main
   add-to-cart is untouched (Horizon updates the bag for it and never fires these).
============================================================= */
(function () {
  'use strict';

  function cartIcon() { return document.querySelector('cart-icon'); }

  function setBag(count, animate) {
    var ci = cartIcon();
    if (!ci || typeof ci.renderCartBubble !== 'function') return;
    var cur = ci.currentCartCount;
    if (typeof cur === 'number' && !isNaN(cur) && cur === count) return;
    ci.renderCartBubble(count, animate !== false);
  }

  document.addEventListener('cart:adding', function (e) {
    var ci = cartIcon();
    if (!ci) return;
    var cur = ci.currentCartCount;
    if (typeof cur !== 'number' || isNaN(cur)) cur = 0;
    var opt = e && e.detail && e.detail.optimistic;
    var qty = (opt && opt.qty) || 1;
    setBag(cur + qty, true);
  });

  function reconcile() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setBag(cart.item_count || 0, false); })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.source === 'bb-cart-drawer') return;
    reconcile();
  });
  document.addEventListener('cart:add-failed', reconcile);
})();

/* =============================================================
   Cart drawer images load eagerly.
   The drawer rebuilds its line items with <img loading="lazy">. On an optimistic
   quick-add the image URL usually isn't cached yet, and because the drawer slides
   in via a transform the lazy loader treats the item as off-screen and defers the
   fetch - so the product photo pops in a beat after the text. Cart-drawer items
   are always visible when open, so flip every image inside the drawer's item list
   to eager (high priority) the instant it's inserted.
============================================================= */
(function () {
  'use strict';
  function eagerify(img) {
    if (!img || img.tagName !== 'IMG') return;
    if (img.loading !== 'eager') img.loading = 'eager';
    try { img.fetchPriority = 'high'; } catch (e) {}
  }
  function scan(node) {
    if (!node) return;
    if (node.tagName === 'IMG') { eagerify(node); return; }
    if (node.querySelectorAll) {
      var l = node.querySelectorAll('img');
      for (var i = 0; i < l.length; i++) eagerify(l[i]);
    }
  }
  function attach() {
    var c = document.querySelector('[id^="CartDrawerItems"]');
    if (!c) return false;
    scan(c);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) scan(a[j]);
      }
    }).observe(c, { childList: true, subtree: true });
    return true;
  }
  if (!attach()) {
    document.addEventListener('DOMContentLoaded', attach);
    window.addEventListener('load', attach);
  }
})();
